import React from 'react'
import { Helmet } from 'react-helmet'

const Conversion = () => (
  <div>
    <Helmet>

    </Helmet>
  </div>
)

const ContactCompletePage = () => (
  <div className='contact'>
    <Conversion />
    <h2>お問い合わせ完了</h2>
    <ul className="breadcrumb">
      <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
        <a href="/" itemProp="url">
          <span itemProp="title"><i className="fas fa-home"></i> ホーム</span>
        </a>
      </li>
      <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
        <span itemProp="title"> <i className="fas fa-caret-right"></i> お問い合わせ</span>
      </li>
    </ul>
    <div className='message'>
      お問い合わせありがとうございました。<br/>
      通常、1〜2日でご返信致します。<br/>
      <br/>
      なお、メールアドレスなどの入力不備によりお返事できない場合もございますので、数日後、連絡がない場合はお手数おかけしますが、再度お問い合わせ頂けますと幸いです。<br/>
    </div>
  </div>
)

export default ContactCompletePage


// WEBPACK FOOTER //
// ./src/ContactCompletePage.js